module.exports = __webpack_public_path__ + "media/images/riders/YANA_BELOMOINA-911273799902e38df39ecac37d090067.png";